// Definición de un componente funcional
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MiCorridor from "../../icons/mi-corridor";
import CorridorForm from "./CorridorForm";

const Corridor = ({ onClose, data, reference_id, theme }) => {

    const { t } = useTranslation();
    const isMimetika = theme === 'mimetika-web-ov' || theme === 'mimetika-web-wl1';

    return (
        <div className='px-4 md:px-8 mimetika-corridor'>
            {isMimetika ? (
                <h1 className="text-xl sm:text-3xl uppercase py-3 sm:py-4 test1">
                    {t('MiCorridor')}
                </h1>
            ) : (
                <div className="sm:mb-4 mimetika-corridor">
                    <MiCorridor />
                </div>
            )}
            <CorridorForm data={ data } reference_id={ reference_id } onClose={ onClose }/>
        </div>
    );
}


export default Corridor;
